import {
  FIREBASE_CONFIG,
  isFirebaseConfigured,
} from 'features/push-notification/constants';
import { type FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { getMessaging, isSupported, type Messaging } from 'firebase/messaging';

let firebaseApp: FirebaseApp | null = null;
let messagingInstance: Messaging | null = null;
let messagingInitPromise: Promise<Messaging | null> | null = null;

const ensureFirebaseApp = (): FirebaseApp | null => {
  if (!isFirebaseConfigured()) {
    console.warn(
      '[FCM] Missing VITE_FIREBASE_* — kiểm tra .env / .env.stg trước khi build'
    );
    return null;
  }
  if (firebaseApp) return firebaseApp;
  firebaseApp = getApps().length
    ? (getApps()[0] as FirebaseApp)
    : initializeApp(FIREBASE_CONFIG);
  return firebaseApp;
};

/**
 * Lazy init Messaging — tránh throw khi browser không hỗ trợ / thiếu ENV.
 */
export const getFirebaseMessaging = async (): Promise<Messaging | null> => {
  if (typeof window === 'undefined') return null;
  if (messagingInstance) return messagingInstance;

  if (!messagingInitPromise) {
    messagingInitPromise = (async () => {
      try {
        const app = ensureFirebaseApp();
        if (!app) return null;

        const supported = await isSupported();
        if (!supported) {
          console.warn('[FCM] Messaging not supported in this browser');
          return null;
        }
        messagingInstance = getMessaging(app);
        return messagingInstance;
      } catch (err) {
        console.error('[FCM] getMessaging failed:', err);
        return null;
      }
    })();
  }

  return messagingInitPromise;
};

/** @deprecated Dùng getFirebaseMessaging() */
export const messaging: Messaging | null =
  typeof window !== 'undefined' &&
  'Notification' in window &&
  'serviceWorker' in navigator &&
  'PushManager' in window
    ? (() => {
        try {
          const app = ensureFirebaseApp();
          return app ? getMessaging(app) : null;
        } catch {
          return null;
        }
      })()
    : null;

export { firebaseApp };
